interface UserSummary {
  email: string
  memberDetailsComplete: boolean
}

interface FindUserResult {
  userId: string
  memberDetailsComplete: boolean
}

const findUser = (
  email: string,
  users: Record<string, UserSummary>
): FindUserResult | null => {
  const usersArray = Object.entries(users)
  for (const [userId, user] of usersArray) {
    if (user.email.toLowerCase() === email.trim().toLowerCase()) {
      return {
        userId,
        memberDetailsComplete: user.memberDetailsComplete
      }
    }
  }
  return null
}
export default findUser